import { render, staticRenderFns } from "./subnav.vue?vue&type=template&id=a985f7a4&scoped=true&"
import script from "./subnav.vue?vue&type=script&lang=js&"
export * from "./subnav.vue?vue&type=script&lang=js&"
import style0 from "./subnav.vue?vue&type=style&index=0&id=a985f7a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a985f7a4",
  null
  
)

export default component.exports